<div class="container">
    <h1 class="update_heading"> ROOM  ALLOCATION &nbsp; AND &nbsp; UPDATE  PROFILE </h1>
        <div class="row text-center" style="display: flex; justify-content: space-between;">
            <div class="col-md-5 updateBox">
                <div style="display: flex; justify-content: space-between;">
                    <h2> Update Profile </h2>
                    <h2> <fa-icon [icon]="faUserCircle" class="fa-lg"></fa-icon> </h2>
                </div>
                <hr>
                <button class="btn room_alloc_button" [disabled]="isEditProfileDisabled" [routerLink]="['/update']" > Update </button>
            </div>
            <div class="col-md-5 updateBox">
                <div style="display: flex; justify-content: space-between;">
                    <h2> Room Allocation Form</h2>
                    <h2> <fa-icon [icon]="faFile" class="fa-lg"></fa-icon> </h2>
                </div>
                <hr>
                <button class="btn room_alloc_button" [disabled]="isRAButtonDisabled" data-toggle="modal" data-target="#roomAllocFormModal" > View Form</button>
            </div>
        </div>
</div>

<div class="modal fade" id="roomAllocFormModal" tabindex="-1" aria-labelledby="roomAllocFormModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
        <div class="modal-body">
            <div style="display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
            </div>
            <div class="scroll" style="width: 100%; padding: 15px;">
                <form>
                    <p style='text-align:center; margin: 20px 0px; font-size: 18px; font-weight: 600;'> Room Allocation Form  </p>
                    <p class="ten_name"> Dear {{ user.name }}, </p>
                    <p><span style="font-weight: 400;">It was a pleasure to meet you at </span><span style="font-weight: 600;"> {{tenantProp[0].property.name }} </span><span style="font-weight: 400;"> during site visit. We are delighted to note that you approve of our property and have decided to go ahead. We look forward to a long and fruitful association. However, note that the same is subject to you providing us with the token advance and your KYC information and supporting documents as specified in sections.</span></p>
                    <h4>&nbsp;</h4>
            
                    <table border="1" cellspacing="2" cellpadding="10">
                        <tr>
                            <th style="width: 150px;"> Name of Prospect </th>
                            <td> {{ user.name }} </td>
                        </tr>
                        <tr>
                            <th> Permanent Address </th>
                            <td> {{tenantProp[0].property.addressl1}}, {{tenantProp[0].property.city}}, {{tenantProp[0].property.state}},{{tenantProp[0].property.country}}. </td>
                        </tr>
                        <tr>
                            <th> Email ID </th>
                            <td> {{ user.email}} </td>
                        </tr>
                        <tr>
                            <th>  Phone Number </th>
                            <td> {{ user.phone }} </td>
                        </tr>
                        <tr>
                            <th> Aprt. of Interest </th>
                            <td> {{tenantProp[0].property.name}} </td>
                        </tr>
                        <tr>
                            <th> Rent </th>
                            <td class="room_amt"> &#x20B9;  {{tenantProp[0].rent}}  </td>
                        </tr>
                        <tr>
                            <th> Deposit </th>
                            <td class="room_amt">  &#x20B9; {{ tenantProp[0].deposite }}  </td>
                        </tr>
                        <tr>
                            <th> Token</th>
                            <td class="room_amt">  &#x20B9; {{tenantProp[0].rent}}   </td>
                        </tr>
                        <tr>
                            <th> Move-in Date&nbsp;&nbsp;&nbsp; </th>
                            <td> {{ tenantProp[0].occupfrom }} </td>
                        </tr>
                        <tr>
                            <th> Proposed Signing Date</th>
                            <td> {{ tenantProp[0].signing_date}} </td>
                        </tr>
                        <tr>
                            <th> Move in charges payable to&nbsp; Society (if any) </th>
                            <td class="room_amt">  &#x20B9; {{tenantProp[0].movein_charges}}  </td>
                        </tr>
                        <tr>
                            <th> Apt. Amenities</th>
                            <td> {{tenantProp[0].apt_amenities}} </td>
                        </tr>
                        <tr>
                            <th> Parking</th>
                            <td class="room_amt">  &#x20B9; {{tenantProp[0].parkingcharges}}  </td>
                        </tr>
                        <tr>
                            <th> Room Amenities </th>
                            <td> {{ tenantProp[0].room_amenities }} </td>
                        </tr>
                    </table>
                    <div class="p-2">
                    <p style="margin-top: 50px; font-weight: 600;"> The ownership of tenant onboarding is with the Operations Team. For any further information on do contact us on +91 91486 33679 (10.00 am to 7.00 pm) or email to care@yourownroom.com</p> 
                    <p class="room_terms"> Section 2 (BUSINESS PROCESS) </p>   
                    <li class="room_terms" >  Mandatory Pre-onboarding Process to be completed by the tenant  </li> 
            
                    <ol>
                        <li class="room_terms">  Update and Verify Room Allocation Form in the platform </li>
                        <li class="room_terms">  Submit Mandatory Documents:  </li>
                            <ul>
                                <li> 4 colour photo passport size </li>
                                <li> Passport/Aadhar Card </li>
                                <li> Driving Licence/ voter id card / Pan Card </li>
                                <li> Copy of your company i-card /First page of your offer letter </li>
                            </ul>
                        <li class="room_terms"> Add 3 references and their details in the dashboard.  </li>
                        <li class="room_terms"> Add Beneficiary to bank account to transfer security deposit.  </li>
                        <li class="room_terms"> Enable easy transfer of the deposit of any large amount after 24 hours of adding. </li>
                        <li class="room_terms"> Any delay in completing the above mandatory process may result in delay in move in date, and not the rent start date.  </li>
                        <li class="room_terms">  During the completion of process, ensure the following:  </li>
                            <ol>
                                <li> Police Verification </li>
                                <li> Drafting of agreement </li>
                                <li> Notarizing the agreement </li>
                                <li> Signing of the agreement </li>
                                <li> Owner's signature of the agreement </li>
                                <li> Agreement to Society </li>
                                <li> Move in to the property on Scheduled date </li>
                            </ol>
                        <li class="room_terms"> The change in process sequence is subject to Police Station, Notary Society Norms and Owner's&nbsp;availability&nbsp;in city at the time of signing the agreement. </li>
                        <li class="room_terms">Conditions: </li>
                            <ol>
                                <li><span>Agreement &amp; Rent is to be kept confidential, breach of confidentiality is subject to financial implication to the extent of loss incurred by YOR.</span></li>
                                <li><span>75% of token amount will be refunded, if booking is cancelled within 24 hours.</span></li>
                                <li><span>50% of Token amount will be refunded, if booking is cancelled after 24 hours and within 48 hours.</span></li>
                                <li><span>No refund of token amount post 48 hours.</span></li>
                                <li><span>The Rental Agreement will be a maximum of 11 months duration with a minimum of 11 month&rsquo;s lock in period for Golden Properties and 6 months for Non-Golden Properties and be renewed with new agreement.</span></li>
                                <li><span>Tenants are required to give a notice period of 30 days to YourOwnROOM, if they choose to vacate the property.&nbsp;</span></li>
                                <li><span>One month&rsquo;s rent will be charged as a penalty if the required rent period is less than 11 months for Golden property and 6 months for Non-Golden Properties.</span></li>
                                <li><span>Administrative Charges of Rs 1,000 (+) 18% GST (for police and or other verification (as per law of the land) and notarized agreement) and Move-Out Charges of </span><span style="font-weight: 600;">15 DAYS</span><span> worth of rent (for painting and cleaning) has to be paid by the Tenant to YourOwnROOM&nbsp;</span></li>
                                <li><span>Society Move-in (Shared with other Flatmates) and Move-out charges (if applicable) has to be paid by the Tenant to Association.</span></li>
                                <li><span>Tenant needs to upload all the required documents and provide references on the platform on the same day of booking, to ensure move in on time, any delay in uploading the document or response from the reference may result in delay of move in.</span></li>
                                <li><span>While in possession of the property, tenants need to abide by the YourOwnROOM policies that are defined in the following links</span></li>
                            </ol>
                        <li class="room_terms"> YourOwnROOM PAN No. AAACY7887N:&nbsp; </li>
                    </ol>
                
                    <li class="room_terms">  User ID, Password, and activate your account  </li>
                        <ul>
                            <li>Open <a href="http://www.yourownroom.com"><span style="font-weight: 400;">www.yourownroom.com</span></a><span style="font-weight: 400;"> in your bowser</span></li>
                            <li>Click on Login button on the top right-hand corner</li>
                            <li>Click on &lsquo;Sign up Now&rsquo; link in the bottom of Login pop-up window.</li>
                            <li>Provide all the information required and click on &lsquo;Register&rsquo;.</li>
                            <li>An activation mail will be sent to the email id provided. Click on the activation link provided in that mail to activate your account. </li>
                        </ul>
                    <li class="room_terms">  Token Deposit     </li>
                        <ol>
                            <li>Log on to <a href="http://www.yourownroom.com"><span style="font-weight: 400;">www.yourownroom.com</span></a></li>
                            <li>Search and open the property of you have liked</li>
                            <li>Click on the room you want to book</li>
                            <li>Click on &lsquo;<span style="font-weight: 600;">Subscribe Now</span><span style="font-weight: 400;">&rsquo; button to pay the Token Deposit equal to 1 month&rsquo;s rent</span></li>
                        </ol>
                        <div class="col-md-offset-13 col-md-12 col-sm-6 col-xs-6">
                            <a (click)="submitRaForm()" class="btn btn-success mt-3" style="margin-left: 25%; margin-right: 25%; width: 50%;">Submit</a>
                        </div>
                    </div>
                </form> 
                </div>
        </div>
        </div>
    </div>
    </div>
</div>


